var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-0.018 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0.018 0.011)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M31.829,6.25A25.583,25.583,0,0,0,6.25,31.829V72.752A25.583,25.583,0,0,0,31.829,98.331H72.752A25.583,25.583,0,0,0,98.331,72.752V31.829A25.583,25.583,0,0,0,72.752,6.25ZM82.984,16.482A5.115,5.115,0,1,1,77.869,21.6,5.116,5.116,0,0,1,82.984,16.482ZM52.291,26.712A25.579,25.579,0,1,1,26.712,52.291,25.583,25.583,0,0,1,52.291,26.712Zm0,10.232A15.347,15.347,0,1,0,67.637,52.291,15.346,15.346,0,0,0,52.291,36.944Z",
    transform: "translate(24.173 24.393)",
    fill: "#273c49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.43c56e2f3e69e8fea953afbb006b64b5.svg";
export { ForwardRef as ReactComponent };